// Depo Yönetimi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.warehousePage';

export const warehousePageGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Depo Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Depolarınızı, her depodaki ürün stoğunu ve depolar arası transferleri bu sayfadan yönetirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Sekmeler'),
    toolbar: t(`${G}.regions.toolbar`, 'Depolar / Transfer / Excel'),
    table: t(`${G}.regions.table`, 'Sekme içeriği'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Toplam Stok Miktarı, Kritik Stok, Bugünkü Stok Hareketi (giriş / çıkış sayısı) ve Hareketsiz Ürün (90 gün) kartları depolarınızın genel durumunu gösterir.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Depo ekleyin, stok aktarın'),
      text: t(`${G}.s2.text`, '"Depolar" düğmesi depo tanımlama penceresini açar; yeni depo ekleme ve düzenleme orada yapılır. "Depo Stok Aktar" (mobilde "Transfer") bir depodaki stoğu başka bir depoya taşıma penceresini açar. İki pencerenin de kendi rehberi vardır.'),
      tips: [
        t(`${G}.s2.tip1`, '"Excel İndir" yalnız Depolar sekmesinde çalışır ve depo listesini indirir.'),
        t(`${G}.s2.tip2`, 'Şube yöneticisi yalnız kendi şubesine bağlı depoları görür; depo tanımlama ve transfer düğmeleri ona kapalıdır.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Sekmeyi seçin'),
      text: t(`${G}.s3.text`, 'Depolar: depo listesi. Depo Ürünleri: seçtiğiniz depodaki ürünler ve miktarları. Transfer Fişleri: yapılmış depo transferleri. Şube yöneticisinde, yetkisi varsa Transfer Fişleri yerine Stok Hareketleri sekmesi görünür. Mobilde sekmeler "Sekme Seç" kutusundadır.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Depolar sekmesi'),
      text: t(`${G}.s4.text`, 'Her depo için Depo Adı, Şube, Durum (Varsayılan / Normal), Adres, Açıklama ve Ürün Sayısı görünür. Henüz depo yoksa "Depo Ekle" ile ilk deponuzu oluşturun.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Depo Ürünleri ve miktar düzeltme'),
      text: t(`${G}.s5.text`, 'Önce depoyu seçin; ürünler "Stoğu Olan Ürünler" ve "Stoğu Olmayan Ürünler" olarak iki sekmede listelenir. Sayım farkı varsa satırdaki "Miktar düzelt" düğmesini kullanın.'),
      tips: [
        t(`${G}.s5.tip1`, '"Sayım (yeni miktar)" ile sayılan miktarı ya da "Ekle/Düş (fark)" ile artı / eksi farkı girin; "Sonuç miktar" yeni stoğu gösterir.'),
        t(`${G}.s5.tip2`, '"Sebep" zorunludur. Kaydedince fark kadar stok giriş veya çıkış hareketi oluşur ve depo stoğu değişir.'),
        t(`${G}.s5.tip3`, 'Akıllı (WMS) depoda stok lokasyon bazlı tutulur; şube yöneticisi için bu depolarda miktar düzeltme kapalıdır, düzeltme WMS ekranlarından yapılır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Transfer Fişleri'),
      text: t(`${G}.s6.text`, 'Her transfer bir fiş olarak listelenir (Fiş No, Tarih, Kaynak Depo, Hedef Depo, Ürün Sayısı, Durum). Fiş no, depo veya ürünle arayın, tarih aralığı verin. "Detayları Görüntüle" fişi açar; buradan "Yazdır" ile çıktı alabilirsiniz.'),
      tips: [
        t(`${G}.s6.tip1`, '"İşlemleri Geri Al": transfer edilen tüm ürünler kaynak depoya geri aktarılır ve transfer fişi silinir. Bu işlem geri alınamaz.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s7.title`, '7. Sayfalar arasında gezin'),
      text: t(`${G}.s7.text`, 'Listeler uzunsa alttaki sayfalama ile ilerleyin. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
